export const host='https://bo.beachcomber-hotels.com'
export const bch_host = 'https://api.beachcomber-hotels.com'
export const link = "https://b2bapi.beachcomber-hotels.com/?q=b2b&a=" 
export const basename= ''